import {GET_TASK_GROUPS, GET_TASK_DETAILS, GET_TASK_QUESTIONS, GET_PLANS_SUCCESS} from '../actions/Tasks';

const questionsData = [];

const initialState = {
    day1_tasks: [],
    day2_tasks: [],
    taskData: {},
    task_questions: [],
    subscription_plans: [],
}

const Task_reducer = (state = initialState, { type, payload }) => {

    switch(type)
    {
        case GET_TASK_GROUPS :
            return Object.assign({}, state, { day1_tasks : payload.groups.day1, day2_tasks: payload.groups.day2 });

        case GET_TASK_DETAILS :
            return Object.assign({}, state, { taskData : payload.taskData });

        case GET_TASK_QUESTIONS :
            return Object.assign({}, state, { task_questions : payload.questions });

        case GET_PLANS_SUCCESS :
            return Object.assign({}, state, {subscription_plans: payload.plans});

        default :
            return state;
    }
}

export default Task_reducer;
